export default {
  dataIterator: {
    rowsPerPageText: 'Elem oldalanként:',
    rowsPerPageAll: 'Mind',
    pageText: '{0}-{1} / {2}',
    noResultsText: 'Nincs egyező találat',
    nextPage: 'Következő oldal',
    prevPage: 'Előző oldal'
  },
  dataTable: {
    rowsPerPageText: 'Elem oldalanként:'
  },
  noDataText: 'Nincs elérhető adat',
  carousel: {
    prev: 'Korábbi vizuális',
    next: 'Következő vizuális'
  }
}
